import { Camera, Sparkles, Smartphone, TrendingDown, Flame, Droplets, Palette, Wand2 } from "lucide-react";
import { Container } from "./shared";
import { SectionHeader } from "./Problem";

const STEPS = [
  { icon: Camera, title: "The homeowner sends photos", text: "They open your link, pick the service, snap 1–8 photos and answer a few quick questions. No app, no account." },
  { icon: Sparkles, title: "AI builds the scope and price range", text: "Squadrum writes a clear scope of work, a preliminary price range, red flags and questions to ask on site." },
  { icon: Smartphone, title: "You get the lead on your phone", text: "An email alert lands instantly. Open it on the job site and call, text or email with one tap." },
];

const BENEFITS = [
  { icon: TrendingDown, title: "Fewer wasted visits", text: "See the space, the size and the budget first. Only drive out for jobs that fit." },
  { icon: Flame, title: "Leads ranked Hot, Warm or Cold", text: "Timeline, budget and clarity are scored for you, so you call the best leads first." },
  { icon: Droplets, title: "Moisture and mold alerts", text: "AI flags staining, mold, cracks and other red flags it spots in the photos before you arrive." },
  { icon: Palette, title: "A link with your brand", text: "Your logo, your color, your link name. Put it on your website, Google profile and truck." },
  { icon: Wand2, wide: true, title: "Show homeowners their finished space before you visit.", text: "From their own photo, AI creates a before-and-after illustration in the style they pick, branded with your company name and emailed to them." },
];

export const HowItWorks = () => (
  <section className="py-20 sm:py-28" data-testid="landing-how-it-works">
    <Container>
      <SectionHeader eyebrow="How it works" title="From photos to a qualified lead in about a minute." />
      <ol className="mt-12 grid gap-5 md:grid-cols-3">
        {STEPS.map(({ icon: Icon, title, text }, i) => (
          <li key={title} className="relative rounded-2xl border border-slate-200 bg-white p-6" data-testid={`how-step-${i + 1}`}>
            <span className="absolute right-5 top-5 font-display text-5xl font-extrabold text-slate-100">{i + 1}</span>
            <span className="relative flex h-12 w-12 items-center justify-center rounded-xl bg-[color:var(--brand)] text-white"><Icon className="h-6 w-6" /></span>
            <p className="relative mt-5 font-display text-lg font-bold text-slate-900">{title}</p>
            <p className="relative mt-2 text-[15px] leading-relaxed text-slate-600">{text}</p>
          </li>
        ))}
      </ol>
    </Container>
  </section>
);

export const Benefits = () => (
  <section className="border-y border-slate-200 bg-white py-20 sm:py-28" data-testid="landing-benefits">
    <Container>
      <SectionHeader eyebrow="Why contractors and home service pros use it" title="Spend your time on jobs you'll actually win." />
      <div className="mt-12 grid gap-4 sm:grid-cols-2">
        {BENEFITS.map(({ icon: Icon, title, text, wide }, i) => (
          <div key={title} className={`group rounded-2xl ${wide ? "sm:col-span-2" : ""} border border-slate-200 bg-slate-50 p-6 transition-[border-color,transform] duration-200 hover:-translate-y-0.5 hover:border-slate-300`}
            data-testid={`benefit-card-${i + 1}`}>
            <Icon className="h-7 w-7 text-[color:var(--brand)]" strokeWidth={1.75} />
            <p className="mt-4 font-display text-xl font-bold text-slate-900">{title}</p>
            <p className="mt-2 text-[15px] leading-relaxed text-slate-600">{text}</p>
          </div>
        ))}
      </div>
    </Container>
  </section>
);
